<script>
import { mapGetters } from 'vuex';
import ProductAttributesMixin from '../mixins/product-attributes';

export default {
  name: 'ComparedProductListItemBar',
  props: ['product', 'productNumber'],
  mixins: [ProductAttributesMixin],
  computed: {
    ...mapGetters({
      comparedProducts: 'compare/products',
    }),
  },
  methods: {
    deleteProduct() {
      this.$store.dispatch('compare/deleteProduct', this.product);
    },
  },
};
</script>

<template>
  <div class="px-2 py-3 bg-white shadow rounded-lg overflow-hidden sm:p-3
    flex justify-between items-center"
  >
    <dd class="mt-1 text-sm font-semibold text-gray-900">
      {{ productName }}
    </dd>
    <button
      type="button"
      @click="deleteProduct"
      class="rounded-md inline-flex text-gray-400 hover:text-gray-500
              focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
    >
      <i class="fas fa-times text-md"></i>
    </button>
  </div>
</template>
